import { type Discount } from '@carvana/merch-contracts';
import { isSuccess, type Result } from '@carvana/merch-result';
import queryString from 'query-string';
import { axios } from '~/clients';
import { DISCOUNTS_LEGACY } from '~/constants/endpoints';
import { logError } from '~/utilities/loggers';

type LegacyDiscountResponse = {
  asOf: string;
  discounts: Discount[];
  excludedPromotionalStates: string[];
  purchaseId?: number;
  userId?: string;
};

export default async function fetchDiscountsLegacy(
  stateAbbreviation: string,
  userId: string,
  controller?: AbortController
): Promise<Discount[]> {
  const query = queryString.stringify({ stateAbbreviation, userId });

  const { data } = await axios.get<Result<LegacyDiscountResponse>>(
    `${DISCOUNTS_LEGACY}?${query}`,
    { signal: controller?.signal }
  );

  if (!isSuccess(data)) {
    logError(new Error(data.errorMessage), {
      location: 'fetchDiscountsLegacy',
      stateAbbreviation,
      userId
    });

    return [];
  }

  return data.content.discounts;
}
